import { z } from 'zod';
/** Style demo-data slice — Trading Identity / Trading Style Profile reference inputs: TI_STYLES, TI_EXP, TI_SESSIONS,
 *  TI_INSTRUMENTS, TI_SYMGROUP, TI_SYSTEM_RULES (design-reference script lines 3542–3570). Deterministic, labeled simulated. */
/** [id, label, subtitle, icon, hold time, trade frequency, colour token, description, suggested max trades/day] */
export const TiStyleSchema = z.tuple([
  z.string(),
  z.string(),
  z.string(),
  z.string(),
  z.string(),
  z.string(),
  z.string(),
  z.string(),
  z.number(),
]);
/** [id, label, description] */
export const TiExpSchema = z.tuple([z.string(), z.string(), z.string()]);
export const StyleDataSchema = z
  .object({
    styles: z.array(TiStyleSchema),
    exp: z.array(TiExpSchema),
    sessions: z.array(z.string()),
    instruments: z.array(z.string()),
    /** symbol → instrument group label (TI_SYMGROUP) */
    symGroup: z.record(z.string(), z.string()),
    systemRules: z.array(z.string()),
  })
  .strict();
export type StyleData = z.infer<typeof StyleDataSchema>;
export type TiStyle = z.infer<typeof TiStyleSchema>;
export type TiExp = z.infer<typeof TiExpSchema>;
